import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor( private authService: AuthService) { }

  ngOnInit(): void {
    console.log(JSON.parse(localStorage.getItem('userSession')).ID_PERFIL);
    
  }

}
